<script setup>
defineProps({
  title:  { type: String, default: '' },
  padded: { type: Boolean, default: true },
})
</script>

<template>
  <section
    class="bg-[color:var(--surface)] border border-[color:var(--line)] rounded-[var(--radius-lg)]"
    :class="padded ? 'p-5' : ''"
  >
    <header
      v-if="title || $slots.title || $slots.actions"
      class="flex items-center justify-between mb-4"
    >
      <h2
        v-if="title"
        class="text-sm font-semibold text-[color:var(--ink)]"
      >
        {{ title }}
      </h2>
      <slot
        v-else
        name="title"
      />
      <div
        v-if="$slots.actions"
        class="flex items-center gap-2"
      >
        <slot name="actions" />
      </div>
    </header>
    <slot />
  </section>
</template>
